export default __webpack_public_path__ + "574b10ef643ef1bc9a17c73e16b3b8a8.jpg";